<div class="wrapper">
	<img src="assets/images/statuses/{{ status | lowercase }}.svg"/>
</div>